import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Text, { TextLink } from '@lightspeed/cirrus-text';

// This is required for Firefox to behave when we have `word-break: break-word`
// See https://css-tricks.com/flexbox-truncated-text
const staticFieldStyle = { minWidth: '0' };

/**
 * This component keeps its own local state, but whenever props.watchValue changes,
 * it syncs back up with the parent's initial editable state overwrites its
 * own local state.
 */
class EditableField extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isEditing: Boolean(this.props.initialIsEditing),
    };

    this.editModeOn = this.editModeOn.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    // If the watchValue has changed, we have to sync our isEditing state
    // with the parent component.
    //
    // Use-case: user changes locations, we'll have to re-validate whether
    // the field is valid and force edit mode. In other cases where edit mode
    // is manually turned on and switching locations, you want to go back to
    // non-edit mode.
    if (this.props.watchValue !== nextProps.watchValue) {
      this.setState(() => ({
        isEditing: nextProps.initialIsEditing || false,
      }));
    }
  }

  editModeOn(e) {
    this.setState(() => ({
      isEditing: true,
    }));
    e.preventDefault();
  }

  render() {
    const { whenEditing, whenNotEditing } = this.props;
    const { isEditing } = this.state;

    return isEditing ? (
      whenEditing()
    ) : (
      <div className="cr-flex cr-justify-between">
        <div style={staticFieldStyle}>{whenNotEditing()}</div>
        <Text element="div" body>
          <TextLink href="#" bold onClick={this.editModeOn} data-test="editablefield-edit-button">
            Edit
          </TextLink>
        </Text>
      </div>
    );
  }
}

EditableField.propTypes = {
  initialIsEditing: PropTypes.bool,
  whenEditing: PropTypes.func.isRequired,
  whenNotEditing: PropTypes.func.isRequired,
  watchValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default EditableField;
